import { m } from 'framer-motion';
// @mui
import { alpha, useTheme } from '@mui/material/styles';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Card, { CardProps } from '@mui/material/Card';
// components
import Image from 'src/components/image';
import { MotionContainer, varFade } from 'src/components/animate';
import Carousel, { CarouselDots, CarouselArrows, useCarousel } from 'src/components/carousel';

// ----------------------------------------------------------------------

// UPDATE: Cập nhật Type này khớp hoàn toàn với FeaturedItem của bạn
type ItemProps = {
  id: string;
  title: string;
  description: string;
  coverUrl: string;
  vuonTrong_ID?: string;
  losam_ID?: string;
  trangThai?: string;
  soLa?: number;
  diemSucKhoe?: string;
  viTriTrongLo?: string;
  tenLo?: string;
  tenVuong?: string;

};
interface Props extends CardProps {
  list: ItemProps[];
  onItemClick?: (item: ItemProps) => void;
}

interface Props extends CardProps {
  list: ItemProps[];
}

export default function AppFeatured({ list, onItemClick, ...other }: Props) {
  const carousel = useCarousel({
    speed: 800,
    autoplay: true,
    ...CarouselDots({
      sx: {
        top: 16,
        left: 16,
        position: 'absolute',
        color: 'primary.light',
      },
    }),
  });

  return (
    <Card {...other}>
      <Carousel ref={carousel.carouselRef} {...carousel.carouselSettings}>
        {list.map((app, index) => (
          <CarouselItem key={app.id} onClick={() => onItemClick?.(app)} item={app} active={index === carousel.currentIndex} />
        ))}
      </Carousel>
 
      <CarouselArrows
        onNext={carousel.onNext}
        onPrev={carousel.onPrev}
        sx={{ top: 8, right: 8, position: 'absolute', color: 'common.white' }}
      />
    </Card>
  );
}

// ----------------------------------------------------------------------

type CarouselItemProps = {
  item: ItemProps;
  active?: boolean;
};

function CarouselItem({ item, active, onClick }: CarouselItemProps & { onClick?: () => void }) {
  const theme = useTheme();
  const { coverUrl, title, tenLo, tenVuong, soLa, trangThai, diemSucKhoe } = item;
 
  return (
    <MotionContainer 
      action 
      animate={active} 
      onClick={(e) => {
        e.preventDefault();
        if (onClick) onClick();
      }}
      sx={{ 
        position: 'relative', 
        cursor: 'pointer', // Hiện bàn tay khi di chuột vào
        '&:hover': {
          '& .overlay-image': {
            transform: 'scale(1.05)', // Hiệu ứng nhẹ khi hover để biết là nhấn được
          }
        }
      }}
    >
      <Stack
        spacing={1}
        sx={{
          p: 3,
          width: 1,
          bottom: 0,
          zIndex: 9,
          textAlign: 'left',
          position: 'absolute',
          color: 'common.white', 
          pointerEvents: 'none',
        }}
      >
        <m.div variants={varFade().inRight}>
          <Typography variant="overline" sx={{ color: 'primary.light' }}>
            {tenVuong} {tenLo && `• ${tenLo}`}
          </Typography>
        </m.div>

        <m.div variants={varFade().inRight}>
          <Typography variant="h5" noWrap>
            {title}
          </Typography>
        </m.div>

        <m.div variants={varFade().inRight}>
          <Typography variant="body2" noWrap>
            {`Số lá: ${soLa} • Trạng thái: ${trangThai} • Điểm: ${diemSucKhoe}`}
          </Typography>
        </m.div> 
      </Stack> 

      <Image 
        className="overlay-image"
        alt={title}
        src={coverUrl}
        overlay={`linear-gradient(to bottom, ${alpha(theme.palette.grey[900], 0)} 0%, ${
          theme.palette.grey[900]
        } 75%)`}
        sx={{
          transition: 'transform 0.3s ease',
          width: 1,
          height: { xs: 280, xl: 450 },
        }}
      />
    </MotionContainer>
  );
}